





























































































































































































































































































































































































































































































































import { Vue, Component, Model } from 'vue-property-decorator';
import Booking, { Notary } from '@/models/Booking';
import get from 'lodash/get';
import { BACKEND_URL } from '@/helpers/constants';
import {
    postBookingDocumentPrescriber,
    deleteBookingDocumentPrescriber,
    getBookingDocumentPrescriber,
    postBookingDateSignatureAppointmentPrescriber,
    postBookingSendContractMailPrescriber,
    postBookingContractSendPrescriber,
    postBookingSendContractMailPrescriberOtherAddress
} from '@/api/api';
import {
    bookingProgression,
    formatBookingProgression,
} from '@/data/bookingProgression';
import {
    bookingDocumentsTypes,
    formatBookingDocumentsTypes,
} from '@/data/bookingDocumentsTypes';
import formatCustomer from '@/utils/formatCustomer';
import moment from 'moment';
import PlugimmoAddress from '@/components/common/PlugimmoAddress.vue';
import Address from '@/components/common/Address.vue';
import ProgressCheckIcon from 'vue-material-design-icons/ProgressCheck.vue';
import BookingAskSignature from '@/components/prescriber/BookingAskSignature.vue';
import UploadComponent, {
    InputFile,
} from '@/components/common/UploadComponent.vue';
import FileBackend from "@/models/FileBackend";

interface Loaders {
    [index: string]: boolean;
}

interface Files {
    [index: string]: InputFile | null;
}

@Component({
    components: {
        PlugimmoAddress,
        Address,
        ProgressCheckIcon,
        BookingAskSignature,
        UploadComponent,
    },
    filters: {
        formatBookingProgression,
        formatCustomer,
        formatDate(date: string) {
            return moment(date).format('LL');
        },
        formatHour(date: string) {
            return moment(date).format('LT');
        },
        formatNotary(value: Notary | null) {
            if (value) {
                return `${value.firstname} ${value.lastname}`;
            }
            return '';
        },
    },
})
export default class BookingFormPrescriber extends Vue {
    @Model('booking') readonly booking!: Booking | undefined;
    BACKEND_URL = BACKEND_URL;
    downloaded: Boolean = false;
    showConfirm = false;
    mailRequested: boolean = false;
    steps: Boolean = false;
    picked: string = '';
    street: string = '';
    addressComp: string = '';
    city: string = '';
    postalCode: string = '';
    toAddress: string = '';

    files: Files = {
        bookingForm: null,
        loanResquestAttestation: null,
        financingAgreement: null,
        loanOfferSigned: null,
        propertyAttestation: null,
        invoiceDocument: null,
        dgAttestation: null,
        contractCounterSigned: null,
        promoterDirectInvoice: null,
    };

    loaders: Loaders = {
        bookingForm: false,
        loanResquestAttestation: false,
        financingAgreement: false,
        loanOfferSigned: false,
        propertyAttestation: false,
        invoiceDocument: false,
        contractCounterSigned: false,
        promoterDirectInvoice: false,
    };

    mounted() {
        if (!this.booking) {
            return;
        }

        if (this.booking.booking_form) {
            this.files.bookingForm = {
                filename: `${this.booking.booking_form.name}.${
                    this.booking.booking_form.extension
                    }`,
                data: '',
            };
        }

        if (this.booking.dg_attestation) {
          this.files.dgAttestation = {
            filename: `${this.booking.dg_attestation.name}.${
                this.booking.dg_attestation.extension
            }`,
            data: '',
          };
        }

        if (this.booking.promoter_direct_invoice) {
          this.files.promoterDirectInvoice = {
            filename: `${this.booking.promoter_direct_invoice.name}.${this.booking.promoter_direct_invoice.extension}`,
            data: '',
          }
        }

        if (this.booking.contract_counter_signed) {
          this.files.contractCounterSigned = {
            filename: `${this.booking.contract_counter_signed.name}.${this.booking.contract_counter_signed.extension}`,
            data: '',
          }
        }

        if (this.booking.loan_resquest_attestation) {
            this.files.loanResquestAttestation = {
                filename: `${this.booking.loan_resquest_attestation.name}.${
                    this.booking.loan_resquest_attestation.extension
                    }`,
                data: '',
            };
        }

        if (this.booking.financing_agreement) {
            this.files.financingAgreement = {
                filename: `${this.booking.financing_agreement.name}.${
                    this.booking.financing_agreement.extension
                    }`,
                data: '',
            };
        }

        if (this.booking.loan_offer_signed) {
            this.files.loanOfferSigned = {
                filename: `${this.booking.loan_offer_signed.name}.${
                    this.booking.loan_offer_signed.extension
                    }`,
                data: '',
            };
        }

        if (this.booking.property_attestation) {
            this.files.propertyAttestation = {
                filename: `${this.booking.property_attestation.name}.${
                    this.booking.property_attestation.extension
                    }`,
                data: '',
            };
        }

        if (this.booking.invoice_document) {
            this.files.invoiceDocument = {
                filename: `${this.booking.invoice_document.name}.${
                    this.booking.invoice_document.extension
                    }`,
                data: '',
            };
        }
    }

    fileChangeListener(ev: Event, type: string) {
        const target = ev.target as HTMLInputElement;

        if (!target.files) {
            return;
        }
        const file: File = target.files[0];

        const myReader: FileReader = new FileReader();
        myReader.readAsDataURL(file);
        myReader.onloadend = async (loadEvent: any) => {
            if (!this.booking || !this.booking.id) {
                return;
            }

            try {
                await postBookingDocumentPrescriber(this.booking.id, type, {
                    file_name: file.name,
                    document: loadEvent.target.result,
                });

                this.showSuccess('Document importé avec succès');
            } catch (error) {
                this.showError(error, `Erreur lors de l'importation`);
            }
        };
    }

    async downloadBookingDocument(type: string) {
        if (!this.booking || !this.booking.id) {
            return;
        }

        const { data } = await getBookingDocumentPrescriber(
            this.booking.id,
            type
        );

        saveAs(
            data,
            `${formatBookingDocumentsTypes(type)}.${
            data.type.endsWith('zip') ? 'zip' : 'pdf'
            }`
        );
    }

    async onDate(date: moment.Moment): Promise<boolean> {
        if (!this.booking || !this.booking.id) {
            return false;
        }

        try {
            const {
                data,
            } = await postBookingDateSignatureAppointmentPrescriber(
                this.booking.id,
                {
                    dateSignatureAppointment: date.toDate(),
                }
            );

            this.$emit('booking', data);

            return true;
        } catch (e) {
            return false;
        }
    }

    async onSendByMail() {
        if (!this.booking || !this.booking.id) {
            return;
            this.showConfirm = false;
        }

        this.showConfirm = false;

        try {
            if (this.picked == 'other') {
                if (this.street !== '' && this.postalCode !== '' && this.city !== '' && this.toAddress !== '' && this.postalCode.length === 5 && this.postalCode.match(/\d\d\d\d\d/gm) !== null) {
                  if(this.addressComp !== '') {
                    var address = this.toAddress + ' : ' + this.street + ', ' + this.addressComp + ', ' + this.postalCode + ', ' + this.city;
                  } else {
                    var address = this.toAddress + ' : ' + this.street + ', ' + this.postalCode + ', ' + this.city;
                  }
                    await postBookingSendContractMailPrescriberOtherAddress(address, this.booking.id);
                    this.showSuccess('Votre demande a été envoyée');
                } else {
                    const $vs = (this as any).$vs;
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Attention',
                        text: 'Il y a une erreur dans l\'adresse que vous nous avez fournie',
                    });
                    return;
                }
            } else if (this.picked == 'client') {
                var address = 'customer';
                await postBookingSendContractMailPrescriberOtherAddress(address, this.booking.id);
                this.showSuccess('Votre demande a été envoyée');
            } else {
                await postBookingSendContractMailPrescriber(this.booking.id);
                this.showSuccess('Votre demande a été envoyée');
            }

            this.mailRequested = true;
        } catch (error) {
            this.showError(error, 'Erreur lors de la demande');
        }
    }

    async onContractSent() {
        if (!this.booking || !this.booking.id) {
            return;
        }

        try {
            const { data } = await postBookingContractSendPrescriber(
                this.booking.id
            );

            this.$emit('booking', data);
            this.showSuccess(`Date d'envoi enregistée`);
        } catch (error) {
            this.showError(error, `Erreur lors de l'enregistrement`);
        }
    }

    async onFile(file: InputFile, type: string) {
        if (!this.booking || !this.booking.id) {
            return;
        }

        try {
            this.loaders[type] = true;
            const { data } = await postBookingDocumentPrescriber(
                this.booking.id,
                type,
                {
                    file_name: file.filename,
                    document: file.data,
                }
            );

            this.$emit('booking', data);
            this.showSuccess('Fichier ajouté');
        } catch (e) {
            this.files[type] = null;
            this.showError(e, `Erreur lors de l'envoi, attention le poids MAX est de 5MB`);
        } finally {
            this.loaders[type] = false;
        }
    }

    async onDelete(type: string) {
        if (!this.booking || !this.booking.id) {
            return;
        }

        deleteBookingDocumentPrescriber(this.booking.id, type)
            .then(() => {
                this.showSuccess('Document supprimé');
                this.files[type] = null;
            })
            .catch(e => {
                this.showError(e, 'Erreur lors de la suppression du document');
            });
    }

    showSuccess(message: string) {
        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: message,
        });
    }

    showError(error: Error, defaultMessage: string) {
        const message = get(error, 'response.data.message', defaultMessage);

        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: message,
        });
    }

    formatFullDate(date: string) {
        return moment(date).format('L');
    }
}
